module.exports = __webpack_public_path__ + "img/Date-icon.cecf0a57.svg";